import revenueText from "./revenue";
import totalCostText from "./total_cost";
import averageHourText from "./average_hour";
import labourCostText from "./labour_cost";
import productivityText from "./productivity";
import overheadFactorsText from "./overhead_factor";
export function getExplanatoryText(index, lang) {
  let explanatoryTexts = [revenueText, totalCostText, averageHourText, labourCostText, productivityText, overheadFactorsText];
  return explanatoryTexts[index][lang];
}
